import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import TextFieldController from "../inputs/TextFieldController";
import PATSaveButton from "../Buttons/PATSaveButton";
import PATCloseButton from "../Buttons/PATCloseButton";

// Validation schema
const perNoteSchema = yup.object().shape({
  note: yup.string().required("Note is required"),
});

const PerNoteDialog = ({ open, onClose, onSave, initialData }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(perNoteSchema),
    defaultValues: {
      note: initialData?.note || "",
    },
  });

  useEffect(() => {
    reset({
      note: initialData?.note || "",
    });
  }, [initialData, reset]);

  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open, reset]);

  const onSubmit = (data) => {
    const noteData = {
      note: data.note?.trim(),
    };
    onSave(noteData);
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{initialData ? "Edit Note" : "Add Note"}</DialogTitle>
      <DialogContent>
        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          sx={{ mt: 1 }}
        >
          <Box sx={{ mb: 2 }}>
            <TextFieldController
              name="note"
              label="Note"
              type="text"
              control={control}
              errors={errors}
              required
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <PATSaveButton onClick={handleSubmit(onSubmit)} tooltipText="Save" />
        <PATCloseButton onClick={onClose} tooltipText="Close" />
      </DialogActions>
    </Dialog>
  );
};

export default PerNoteDialog;
